import { trpc } from '@/lib/trpc'

/** Reads the current user from the sealed session via tRPC. */
export function useAuth() {
  const { data, isLoading } = trpc.auth.me.useQuery(undefined, { retry: false })
  const user = data ?? null
  return { user, isLoading, isAuthenticated: user !== null }
}
